import React from "react";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import Constants from "../../../../common/Constants";
import MasterList from "../../../common/MasterList";
import ModalBody from "../../../common/ModalBody";
import ModalHeader from "../../../common/ModalHeader";

const ViewMachines = (props) => {
  //const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  // const handleClose = () => {
  //   setOpen(false);
  // };
  // const handleOpen = (data) => {
  //   setOpen(true);
  // };
  const columnsData = [
    {
      name: t("msg_master_list.msg_machines.code"),
      selector: (row) => row.machineCode,
      sortable: true,
      width: "180px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.machineCode} </p>
        </div>
      ),
    },
    {
      name: t("msg_master_list.msg_machines.machine_name"),
      selector: (row) => row.machineName,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.machineName} </p>
        </div>
      ),
    },
    {
      name: t("msg_common.status"),
      cell: (row) => (
        <>
          {row.status === Constants.MASTER.STATUS.Active ? (
            <span className="bg-table-status bg-table-success-status">
              {t("msg_common.active")}
            </span>
          ) : row.status === Constants.MASTER.STATUS.Inactive ? (
            <span className="bg-table-status bg-table-danger-status">
              {t("msg_common.inactive")}
            </span>
          ) : (
            row.status
          )}
        </>
      ),
      center: true,
      width: "150px",
    },
  ];
  const { onHide } = props;
  // console.log(">>>>>>>>>",props)
  return (
    <Modal {...props} onHide={onHide} animation={false} size="lg" backdrop="static">
      <ModalHeader
        title={` ${t("msg_master_list.msg_machines.machines_details")} - ${
          props.deptcode
        } `}
      ></ModalHeader>
      <ModalBody>
        <MasterList
          columnsData={columnsData}
          rowsData={props.rowsData?.data}
          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
          pagination
          selectableRows
          handleClose
          cardHeader={false}
          //handleOpen={handleOpen}
          //handleDelete={confirmBeforeDelete}
          //onSelectedRowsChange={handleRowSelected}
        />
      </ModalBody>
    </Modal>
  );
};

export default ViewMachines;
